import { membershipNamesEligibleFor } from "rtr-constants";
import { isSubscriptionLens, isSubscriptionMember } from "helpers/membership-helpers";
import ActionLogger from "action-logger";
import { isBulk, isClearance } from "helpers/price-helper";

// Determines if a product is clearance or bulk. Neither are eligible for this experiment.
function productNotClearanceOrBulk(product) {
  const clearance = isClearance(product?.price);
  const bulk = isBulk(product?.price);

  return !clearance && !bulk;
}

// Determines if a product is eligible for an Unlimited upsell.
function productEligibleForUnlimitedUpsell(product) {
  const eligibleForArr = product?.eligibleFor ?? [];
  return eligibleForArr.includes(membershipNamesEligibleFor.RTRUnlimited);
}

// Determines if a product is eligible for an Update upsell.
function productEligibleForUpdateUpsell(product) {
  const eligibleForArr = product?.eligibleFor ?? [];

  return eligibleForArr.includes(membershipNamesEligibleFor.RTRUpdate);
}

// Determines if a product is eligible for either an Unlimited or Update upsell.
function productEligibleForAnyUpsell(product) {
  return (
    productNotClearanceOrBulk(product) &&
    (productEligibleForUnlimitedUpsell(product) || productEligibleForUpdateUpsell(product))
  );
}

// Determines if a user and product is eligible for seeing a membership upsell on
// the PDP.
function displayMembershipUpsell(userData, product) {
  return !isSubscriptionMember(userData) && productEligibleForAnyUpsell(product);
}

function logMembershipUpsellEligibility(userData, product) {
  ActionLogger.logAction({
    object_type: "pdp",
    action: "display_pdp_upsell",
    active_subs: isSubscriptionMember(userData),
    is_subscription_lens: isSubscriptionLens(userData),
    upsell_eligible_item: productEligibleForAnyUpsell(product),
  });
}

export {
  productEligibleForUpdateUpsell,
  productEligibleForUnlimitedUpsell,
  displayMembershipUpsell,
  logMembershipUpsellEligibility,
};
